      // the rest of this script tag has to do with MG custom stuff var MG
window.MG = {};
 (function() {
    var reconciling = false;
    var _origFetch = window.fetch;

    // Use a small delay to ensure we get _after_ any customize-mg interceptor
    setTimeout(function() {
      var _rFetch = window.fetch;

      async function reconcileFees() {
        if (reconciling) return;
        reconciling = true;
        try {
          var resp = await _origFetch('/cart.js');
          var cart = await resp.json();
          var changed = false;

          var customItems = cart.items.filter(function(i) {
            return i.properties && i.properties['_Custom Image'];
          });
          var feeItems = cart.items.filter(function(i) {
            return i.properties && i.properties['_linked_image'];
          });

          // NEVER blank _Custom Image — the image property is sacred once set.
          // Only manage fee lifecycle: remove orphans and sync quantities.

          // Product removed → remove orphaned fee
          for (var f = 0; f < feeItems.length; f++) {
            var fee = feeItems[f];
            var feeLinkId = fee.properties['_link_id'];
            var linkedImg = fee.properties['_linked_image'];

            // Match by _link_id (precise, handles duplicate images across products)
            // Fall back to image URL for legacy cart items without _link_id
            var match;
            if (feeLinkId) {
              match = customItems.find(function(ci) {
                return ci.properties['_link_id'] === feeLinkId;
              });
            } else {
              match = customItems.find(function(ci) {
                return ci.properties['_Custom Image'] === linkedImg;
              });
            }

            if (!match) {
              await _origFetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: fee.key, quantity: 0 })
              });
              changed = true;
            } else if (match.quantity !== fee.quantity) {
              // Quantity mismatch → sync fee to product
              await _origFetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: fee.key, quantity: match.quantity })
              });
              changed = true;
            }
          }

          if (changed) {
            // Refresh drawer if open
            var cartBody = document.querySelector('[data-cart-drwaer-body]');
            if (cartBody) {
              var secResp = await _origFetch('/?sections=ajax-cart-drawer');
              var sections = await secResp.json();
              if (sections['ajax-cart-drawer']) {
                var doc = new DOMParser().parseFromString(sections['ajax-cart-drawer'], 'text/html');
                var newContent = doc.querySelector('.shopify-section');
                if (newContent) cartBody.innerHTML = newContent.innerHTML;
                var countEl = doc.querySelector('[data-cart-wrapper]');
                if (countEl) {
                  var count = parseInt(countEl.getAttribute('data-item-count')) || 0;
                  document.querySelectorAll('.cart-count, [data-header-cart-count]').forEach(function(el) {
                    el.textContent = count;
                    el.classList.toggle('hidden', count === 0);
                  });
                }
              }
            }
          }
        } finally {
          reconciling = false;
        }
      }

      // Hook into cart changes from any source
      var _currentFetch = window.fetch;
        window.fetch = function() {
        var url = typeof arguments[0] === 'string' ? arguments[0] : '';
        var result = _currentFetch.apply(this, arguments);

        if (url.includes('/cart/change') || url.includes('/cart/update')) {
          result.then(function() {
            setTimeout(reconcileFees, 500);
          });
        }

        return result;
      };
    }, 100);
  })();
